
import { Component, Vue } from 'vue-property-decorator'
import { PersonService } from '@/services'
import { AppModule } from '@/store/modules/app'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import RowItem from '@/components/detail/row_item/index.vue'

const statusMap = new Map([
    [1, { zh: '审核中', en: 'Ing' }],
    [2, { zh: '审核通过', en: 'Pass' }],
    [3, { zh: '审核不通过', en: 'Fail' }]
])

@Component({
    name: 'person-settle-detail',
    components: {
        RowWrap,
        RowItem
    }
})
export default class extends Vue {
    private changeLoading = false
    private personId = ''
    private person: any = { 
        avatar: '', 
        status: '', 
        user: {}, 
        type: { id: '' },
        link: [],
        post: []
    }
    private keywords: string[] = []
    private isUpdateLoading = false
    // 领域选项
    private fieldOptions: any[] = []

    // 匹配状态对象
    get status() {
        let statusKeyValue = {}
        const values = [...statusMap.values()]
        const keys = [...statusMap.keys()]
        values.forEach((val, index) => {
            Reflect.set(statusKeyValue, val.en, keys[index])
        })
        return statusKeyValue
    }

    // 匹配状态中文
    get matchStatusZh() {
        const status = statusMap.get(this.person.status)
        if (!status) return ''
        return status!.zh
    }

    get industrys() {
        return AppModule.industry
    }

    private created() {
        this.personId = this.$route.params.id
        this.$title('loading | 人物详情 - 庖丁')
    }

    private mounted() {
        AppModule.getIndustry()   
        this.getPersonDetail()
    }

    /** 解析后端返回的字符串数组字段 */
    private parseArrayField(value: any): string[] {
        if (Array.isArray(value)) return value
        if (typeof value === 'string' && value) {
            try {
                const parsed = JSON.parse(value)
                return Array.isArray(parsed) ? parsed : []
            } catch (e) {
                return value.split(',')
            }
        }
        return []
    }
    /** 获取人物详情 */
    private async getPersonDetail() {
        const params = {
            id: +this.personId
        }
        const result = await PersonService.getPersonSettleDetail(params)
        if (result.status === 200) {
            const { link, keywords, post, person_type_id } = result.data
            result.data.link = this.parseArrayField(link).map((url: string, index: number) => ({ key: index, value: url }))
            result.data.post = this.parseArrayField(post)
            result.data.type = { id: person_type_id }
            this.keywords = this.parseArrayField(keywords)
            this.person = result.data
            this.$title(`${this.person.name}| 人物详情 - 庖丁`)
        }
    }

    private matchButtonType(status: number) {
        return this.person.status === status ? 'primary' : 'default'
    }

    /** 改变状态 */
    private async changeStatus(status: number) {
        if (this.person.status === status) return
        this.changeLoading = true
        const params = {
            id: +this.personId,
            status
        }
        const result = await PersonService.updatePersonSettleStatus(params)
        this.changeLoading = false
        if (result.status === 200) {
            this.person.status = status
            return this.$message({
                showClose: true,
                type: 'success',
                message: '修改状态成功'
            })
        }
        this.$message({
            showClose: true,
            type: 'error',
            message: result.message || '发生错误, 修改状态失败'
        })
    }

    private showLoading() {
        this.isUpdateLoading = true
    }

    private hideLoading() {
        this.isUpdateLoading = false
    }
}
